import { Button } from '../../../../../primitives/button';
import { ButtonGroup } from '../../../../../primitives/button-group';
import { ColorPicker } from '../../../../../primitives/color-picker';
import { LabelWithoutRef } from '../../../../label/label-without-ref';
import { SelectModel } from '../../../../select/select-model';

import { cn } from '../../../../../utils/cn';

import { EMAIL_COLORS } from '../../constants/colors';
import {
  BUTTON_SIZE_MODEL,
  BUTTON_STYLE_MODEL,
  BUTTON_WIDTH_MODEL,
  type ButtonSize,
  type ButtonStyle,
  type ButtonWidth,
} from './constants';

type AppearanceProps = {
  backgroundColor?: string;
  buttonColor?: string;
  className?: string;
  size?: ButtonSize;
  styleVariant?: ButtonStyle;
  width?: ButtonWidth;
  onButtonBackgroundColor?: (buttonColor?: string | null) => void;
  onBackgroundColorChange?: (backgroundColor?: string | null) => void;
  onSizeChange?: (size: ButtonSize) => void;
  onStyleVariantChange?: (styleVariant: ButtonStyle) => void;
  onWidthChange?: (width: ButtonWidth) => void;
};

export function Appearance({
  backgroundColor,
  buttonColor,
  className,
  size,
  styleVariant,
  width,
  onButtonBackgroundColor,
  onBackgroundColorChange,
  onSizeChange,
  onStyleVariantChange,
  onWidthChange,
}: AppearanceProps) {
  return (
    <div className={cn('space-y-2', className)}>
      <p className="text-xs font-medium">Apariencia</p>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1">
        <div>
          <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
            Tamaño
          </LabelWithoutRef>
          <ButtonGroup className="w-full">
            {BUTTON_SIZE_MODEL.map(({ value, item }) => (
              <Button
                key={value}
                className={cn('w-full', {
                  'bg-accent/80 text-accent-foreground': size === value,
                })}
                title={`Tamaño ${value}`}
                variant="outline"
                size="sm"
                onClick={() => onSizeChange?.(value as ButtonSize)}
              >
                {item}
              </Button>
            ))}
          </ButtonGroup>
        </div>
        <div>
          <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
            Ancho
          </LabelWithoutRef>
          <SelectModel
            model={BUTTON_WIDTH_MODEL}
            size="sm"
            value={width}
            variant="outline"
            onValueChange={(value) => onWidthChange?.(value as ButtonWidth)}
          />
        </div>
        <div>
          <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
            Estilo
          </LabelWithoutRef>
          <SelectModel
            model={BUTTON_STYLE_MODEL}
            size="sm"
            value={styleVariant}
            variant="outline"
            onValueChange={(value) => onStyleVariantChange?.(value as ButtonStyle)}
          />
        </div>
        <div>
          <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
            Color
          </LabelWithoutRef>
          <ColorPicker
            colors={EMAIL_COLORS}
            isCleanColorVisible
            noneColorLabel="Sin personalizar"
            value={buttonColor}
            onValueChange={(value) => onButtonBackgroundColor?.(value ?? null)}
          />
        </div>
        <div>
          <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
            Fondo
          </LabelWithoutRef>
          <ColorPicker
            colors={EMAIL_COLORS}
            isCleanColorVisible
            noneColorLabel="Sin personalizar"
            value={backgroundColor}
            onValueChange={(value) => onBackgroundColorChange?.(value ?? null)}
          />
        </div>
      </div>
    </div>
  );
}
